module.exports = __webpack_public_path__ + "media/images/country_flags/nz-f15adfb873d0e9f5806dc34fb5a715d5.png";